import { Base } from "@app/controllers/base";

// Connects to data-controller="store--addons"
export default class extends Base {
  static targets = ["checkbox", "total", "grandTotal"];
  static values = { basePrice: Number };

  recalculate() {
    const addonTotal = this.checkboxTargets.reduce((sum, cb) => {
      return sum + (cb.checked ? parseInt(cb.value, 10) : 0);
    }, 0);

    const total = this.basePriceValue + addonTotal;
    this.totalTarget.textContent = this.formatIDR(addonTotal);
    if (this.hasGrandTotalTarget) {
      this.grandTotalTarget.textContent = this.formatIDR(total);
    }
  }

  formatIDR(amount) {
    return `Rp ${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }
}
